module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsMaks),
      expression: "tipsMaks"
    }],
    staticClass: "tips-mask-t",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.topMove, 'tips-end': !_vm.topMove
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [(_vm.hasTipsFont) ? _c('div', {
    staticClass: "tips-font"
  }, [_c('p', [_vm._v(_vm._s(_vm.tipsFont))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('a', {
    staticClass: "tips-two-btn tips-marbot red-font",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onConfirmS.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnFont[0]))]), _vm._v(" "), (_vm.btnFont.length > 2) ? _c('a', {
    staticClass: "tips-two-btn tips-marbot",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onSecond.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnFont[1]))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "tips-two-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onCancel.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(_vm.btnFont.length > 2 ? _vm.btnFont[2] : _vm.btnFont[1]))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-269d4953!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TipsT.vue
// module id = 550
// module chunks = 1